import * as types from './actionTypes';
import accountApi from '../api/mockAccountApi';

export function loadAccountSuccess(accounts) {
  return { type: types.LOAD_ACCOUNTS_SUCCESS, accounts}
}

export function loadAccounts() {
  return function (dispatch) {
    return accountApi.getAllAccounts().then(accounts => {
      dispatch(loadAccountSuccess(accounts));
    }).catch(error => {
      throw(error);
    });
  };
}

export function createAccountSuccess(newAccount) {
  return { type: types.CREATE_ACCOUNT_SUCCESS, newAccount}
}

export function createAccount(registration) {
  // return function (dispatch, getState) { // may be needed later
  return function (dispatch) {
    return accountApi.createAccount(registration).then(newAccount => {
      dispatch(createAccountSuccess(newAccount));
    }).catch(error => {
      throw(error);
    });
  };

}



// WEBPACK FOOTER //
// ./src/actions/accountActions.js